import { render, staticRenderFns } from "./Bblist2.vue?vue&type=template&id=d1c144ea&scoped=true"
import script from "./Bblist2.vue?vue&type=script&lang=js"
export * from "./Bblist2.vue?vue&type=script&lang=js"
import style0 from "./Bblist2.vue?vue&type=style&index=0&id=d1c144ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c144ea",
  null
  
)

export default component.exports